import _objectWithoutProperties from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits"; //@ts-check

import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Switch from '@material-ui/core/Switch';
import { fade } from '@material-ui/core/styles/colorManipulator';

var styles = function styles(theme) {
  return {
    root: {
      display: 'inline-flex',
      width: 50,
      position: 'relative',
      left: 7,
      flexShrink: 0,
      height: 20,
      padding: 0,
      verticalAlign: 'middle'
    },
    thumb: {
      boxShadow: '0px 0px 3px 0px rgba(0, 0, 0, 0.2), \
      0px 1px 1px 0px rgba(0, 0, 0, 0.14), \
      0px 2px 1px -1px rgba(0, 0, 0, 0.12)',
      backgroundColor: '#fff',
      width: 10,
      height: 10,
      borderRadius: '50%'
    },
    switchBase: {
      zIndex: 1,
      height: 13,
      width: 30,
      margin: '0 0 1.5px 0',
      '&$checked': {
        transform: 'translateX(' + 11 + 'px)',
        '& + $track': {
          opacity: 1
        }
      }
    },
    checked: {
      transform: 'translateX(' + 11 + 'px)',
      '& + $track': {
        opacity: 1
      }
    },
    disabled: {
      '& + $track': {
        opacity: 1
      },
      '& $thumb': {
        boxShadow: '0px 0px 3px 0px rgba(0, 0, 0, 0.2), \
        0px 1px 1px 0px rgba(0, 0, 0, 0.14), \
        0px 2px 1px -1px rgba(0, 0, 0, 0.12)'
      },
      '&$switchBase': {
        color: '#ccc',
        '&$checked + $track': {
          backgroundColor: fade(theme.palette.primary.main, 0.5)
        },
        '& + $track': {
          backgroundColor: fade('#000', 0.15)
        }
      }
    },
    track: {
      borderRadius: 14 / 2,
      display: 'block',
      position: 'absolute',
      width: 25,
      height: 13,
      top: '50%',
      left: '50%',
      marginTop: -7,
      marginLeft: -17,
      backgroundColor: fade('#000', 0.15),
      opacity: 1
    }
  };
};
/**
 * @extends {React.Component<import('../types').FormInputSwitchProps & import('@material-ui/core').WithStyles<typeof styles>> }
 */


var SwitchFormInput =
/*#__PURE__*/
function (_React$Component) {
  _inherits(SwitchFormInput, _React$Component);

  function SwitchFormInput() {
    _classCallCheck(this, SwitchFormInput);

    return _possibleConstructorReturn(this, _getPrototypeOf(SwitchFormInput).apply(this, arguments));
  }

  _createClass(SwitchFormInput, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          classes = _this$props.classes,
          disabled = _this$props.disabled,
          value = _this$props.value,
          checked = _this$props.checked,
          rest = _objectWithoutProperties(_this$props, ["classes", "disabled", "value", "checked"]);

      var isChecked = false;

      if (value) {
        if (typeof value === 'string') isChecked = value === 'Yes';else if (typeof value === 'boolean') isChecked = value;
      } else if (typeof checked !== 'undefined') {
        isChecked = !!checked;
      }

      return React.createElement(Switch, Object.assign({
        color: "primary",
        classes: {
          root: classes.root,
          switchBase: classes.switchBase,
          thumb: classes.thumb,
          track: classes.track,
          checked: classes.checked,
          disabled: classes.disabled
        },
        disableRipple: true,
        disabled: disabled,
        checked: isChecked
      }, rest));
    }
  }]);

  return SwitchFormInput;
}(React.Component);

export default withStyles(styles, {
  name: 'ECSwitchFormInput'
})(SwitchFormInput);